import * as Yup from 'yup';

// Defaults
export const formValues = {
    date: Date.now(),
    warehouse: '',
    container: '',
    income: 0,
    disposal: 0,
    loadingCode: '',
    client: '',
    clientBranchId: '',
    note: '',
    acronym: '',
    weight: 0,
}

export const validation = () => (
    Yup.object({
        date: Yup.string()
            .required('Názov evidenčného listu je povinný.'),
        warehouse: Yup.string()
            .max(25, 'Maximálny počet znakov je 25.'),
        container: Yup.string()
            .max(25, 'Maximálny počet znakov je 25.'),
        income: Yup.number()
            .typeError('Príjem musí byť číslo')
            .nullable()
            .min(0, 'Číslo musí byť väčšie alebo rovné 0')
            .max(9999, 'Maximálny príjem je 9999.')
            .required('Prosím vyplňte príjem.')
            .test('is-zero', 'Môžete zadať príjem, alebo výdaj.', function(value) {
                return this.parent.disposal === 0 || value === 0
                
            })
            .test(
                'max-decimals',
                'Príjem môže mať maximálne 3 desatinné miesta.',
                (value) => (value ? /^\d+(\.\d{1,3})?$/.test(value.toString()) : true)
            ),
        disposal: Yup.number()
            .typeError('Výdaj musí byť číslo')
            .nullable()
            .min(0, 'Číslo musí byť väčšie alebo rovné 0')
            .max(9999, 'Maximálny výdaj je 9999.')
            .required('Prosím vyplňte výdaj.')
            .test('is-zero', 'Môžete zadať príjem, alebo výdaj.', function(value) {
                return this.parent.income === 0 || value === 0;
            })
            .test('zpr-income-only', 'Pri skratke ZPR môžete vyplniť iba vznik/príjem.', function(value) {
                return this.parent.acronym !== 'ZPR' || !value;
            })
            .test(
                'max-decimals',
                'Výdaj môže mať maximálne 3 desatinné miesta.',
                (value) => (value ? /^\d+(\.\d{1,3})?$/.test(value.toString()) : true)
            ),
        loadingCode: Yup.string()
            .required('Kód nakladania je povinný.'),
        client: Yup.string()
            .max(25, 'Maximálny počet znakov je 25.')
            .required('Spoločnosť je povinná.'),
        clientBranchId: Yup.string(),
        note: Yup.string()
            .max(15, 'Maximálny počet znakov je 15.'),
        acronym: Yup.string()
            .max(10, 'Maximálny počet znakov je 10.'),
    })
)